/* AISEN FLOOR — calculadora multiambiente: estado, render, carrinho e persistência.
   O cálculo em si vive em aisen-floor-engine.js (window.AisenFloorEngine).
   Custom element vanilla, sem bibliotecas, seguindo o padrão das demais calculadoras do tema. */
(() => {
  const E = window.AisenFloorEngine;
  if (!E) return;
  const { STATUS, CONTROL } = E;

  const STORAGE_KEY = 'aisen-floor-project';
  const STORAGE_VERSION = 2; // v2: ambientes passam a guardar comprimento e largura

  const nf = (n, dp) => Number(n).toLocaleString('pt-BR', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  const area = (n) => nf(n, n % 1 ? 2 : 0) + ' m²';
  const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

  const STATUS_LABEL = {
    [STATUS.VALID]: 'Acionamento direto',
    [STATUS.TECHNICAL_REVIEW]: 'Análise técnica',
    [STATUS.NO_COMBINATION]: 'Análise técnica',
    [STATUS.INVALID_INPUT]: 'Dados incompletos',
  };

  class AisenFloorCalc extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';

      this.cfg = Object.assign({}, E.AISEN_FLOOR_CONFIG);
      this.catalog = {};
      this.rolls = E.AISEN_FLOOR_ROLLS.map((r) => Object.assign({}, r));
      try {
        const data = JSON.parse(this.querySelector('[data-catalog]').textContent);
        this.catalog = data.aux || {};
        this.rolls = this.rolls.map((r) => {
          const e = (data.rolls || {})[r.id];
          const isObj = e && typeof e === 'object';
          return Object.assign({}, r, { variantId: isObj ? e.variantId : (e || null), image: isObj ? e.image : null });
        });
      } catch (e) {}
      this.thermostats = E.getThermostatOptions(this.catalog);
      this.icons = {};
      try { this.icons = JSON.parse(this.querySelector('[data-icons]').textContent); } catch (e) {}

      this.listEl = this.querySelector('[data-envs]');
      this.resultsEl = this.querySelector('[data-results]');
      this.summaryEl = this.querySelector('[data-summary]');
      this.feedbackEl = this.querySelector('[data-feedback]');
      this.project = null;

      this.environments = this.restore() || [this.newEnv(1)];
      this.renderEnvs();

      this.querySelector('[data-add-env]').addEventListener('click', () => this.addEnv());
      this.querySelector('[data-calc]').addEventListener('click', () => this.calculate());
      const clear = this.querySelector('[data-clear]');
      if (clear) clear.addEventListener('click', () => this.clearProject());
      this.addEventListener('click', (ev) => {
        const add = ev.target.closest('[data-add-cart]');
        if (add) { ev.preventDefault(); this.addToCart(add); }
      });
    }

    newEnv(n) {
      const first = (this.thermostats && this.thermostats[0]) || null;
      return {
        zoneId: 'zone-' + n + '-' + Math.random().toString(36).slice(2, 6), zoneNumber: n,
        environmentName: '', lengthMeters: '', widthMeters: '',
        thermostatId: first ? first.id : null,
      };
    }

    /* ---------- persistência (sessionStorage, versionada) ---------- */
    save() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          version: STORAGE_VERSION, savedAt: new Date().toISOString(),
          project: { environments: this.environments },
        }));
      } catch (e) {}
    }
    restore() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const d = JSON.parse(raw);
        if (!d || d.version !== STORAGE_VERSION) return null;
        const envs = d.project && d.project.environments;
        return Array.isArray(envs) && envs.length ? envs : null;
      } catch (e) { return null; }
    }
    clearProject() {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      this.environments = [this.newEnv(1)];
      this.project = null;
      this.resultsEl.innerHTML = '';
      this.summaryEl.innerHTML = '';
      this.summaryEl.hidden = true;
      this.feedbackEl.hidden = true;
      this.renderEnvs();
      this.announce('Projeto limpo.');
    }

    /* ---------- ambientes ---------- */
    addEnv() {
      if (this.environments.length >= this.cfg.maximumEnvironmentCount) {
        this.announce('Limite de ' + this.cfg.maximumEnvironmentCount + ' ambientes atingido.');
        return;
      }
      this.environments.push(this.newEnv(this.environments.length + 1));
      this.renderEnvs();
      const inputs = this.listEl.querySelectorAll('[data-name]');
      const last = inputs[inputs.length - 1];
      if (last) last.focus();
      this.save();
    }
    removeEnv(i) {
      if (this.environments.length <= 1) return;
      this.environments.splice(i, 1);
      this.environments.forEach((e, k) => { e.zoneNumber = k + 1; });
      this.renderEnvs();
      const btns = this.listEl.querySelectorAll('[data-remove]');
      const target = btns[Math.min(i, btns.length - 1)];
      if (target) target.focus(); else this.querySelector('[data-add-env]').focus();
      this.save();
    }

    renderEnvs() {
      this.listEl.innerHTML = '';
      this.environments.forEach((env, i) => {
        const card = el('div', 'aisen-fc__env');
        const head = el('div', 'aisen-fc__envhead');
        head.appendChild(el('span', 'aisen-fc__envn', 'Ambiente ' + (i + 1)));
        if (this.environments.length > 1) {
          const rm = el('button', 'aisen-fc__rm');
          rm.type = 'button';
          rm.setAttribute('data-remove', String(i));
          rm.setAttribute('aria-label', 'Remover ambiente ' + (i + 1));
          if (this.icons.remove) {
            const ic = el('img'); ic.className = 'aisen-fc__rmic'; ic.src = this.icons.remove;
            ic.alt = ''; ic.setAttribute('aria-hidden', 'true'); ic.width = 14; ic.height = 14;
            rm.appendChild(ic);
          }
          rm.appendChild(document.createTextNode('Remover'));
          rm.addEventListener('click', () => this.removeEnv(i));
          head.appendChild(rm);
        }
        card.appendChild(head);

        const idN = 'afc-name-' + env.zoneId;
        const idL = 'afc-len-' + env.zoneId;
        const idW = 'afc-wid-' + env.zoneId;
        const idE = 'afc-err-' + env.zoneId;

        // nome em linha própria
        const fName = el('div', 'aisen-fc__field');
        const lName = el('label', 'aisen-fc__label', 'Nome do ambiente'); lName.htmlFor = idN;
        const iName = el('input', 'aisen-fc__input');
        iName.type = 'text'; iName.id = idN; iName.placeholder = 'Ex.: Banheiro suíte, quarto, sala';
        iName.value = env.environmentName || ''; iName.setAttribute('data-name', '');
        iName.addEventListener('input', () => { env.environmentName = iName.value; this.save(); });
        fName.append(lName, iName);
        card.appendChild(fName);

        // comprimento e largura lado a lado
        const dims = el('div', 'aisen-fc__envgrid');
        const mkDim = (id, label, key, attr) => {
          const f = el('div', 'aisen-fc__field');
          const l = el('label', 'aisen-fc__label', label); l.htmlFor = id;
          const i = el('input', 'aisen-fc__input');
          i.type = 'text'; i.id = id; i.inputMode = 'decimal'; i.placeholder = '0,00';
          i.value = env[key] == null ? '' : String(env[key]);
          i.setAttribute(attr, ''); i.setAttribute('aria-describedby', idE);
          i.addEventListener('input', () => { env[key] = i.value; this.updateArea(env, card); this.save(); });
          f.append(l, i);
          return f;
        };
        dims.append(
          mkDim(idL, 'Comprimento (m)', 'lengthMeters', 'data-length'),
          mkDim(idW, 'Largura (m)', 'widthMeters', 'data-width')
        );
        card.appendChild(dims);

        // termostato por ambiente — só aparece quando há mais de um modelo configurado
        if (this.thermostats.length > 1) {
          const idT = 'afc-th-' + env.zoneId;
          const fT = el('div', 'aisen-fc__field aisen-fc__field--th');
          const lT = el('label', 'aisen-fc__label', 'Termostato'); lT.htmlFor = idT;
          const sel = el('select', 'aisen-fc__select');
          sel.id = idT; sel.setAttribute('data-thermostat', '');
          this.thermostats.forEach((o) => {
            const op = el('option', null, o.title);
            op.value = o.id;
            if (env.thermostatId === o.id) op.selected = true;
            sel.appendChild(op);
          });
          if (!env.thermostatId) env.thermostatId = this.thermostats[0].id;
          sel.addEventListener('change', () => { env.thermostatId = sel.value; this.save(); });
          fT.append(lT, sel);
          card.appendChild(fT);
        }

        const areaLine = el('p', 'aisen-fc__areacalc');
        areaLine.setAttribute('data-areacalc', '');
        card.appendChild(areaLine);

        const err = el('p', 'aisen-fc__err'); err.id = idE; err.hidden = true;
        card.appendChild(err);

        this.listEl.appendChild(card);
        this.updateArea(env, card);
      });
    }

    // área é derivada: o cliente nunca digita m²
    updateArea(env, card) {
      const out = card.querySelector('[data-areacalc]');
      if (!out) return;
      const L = E.normalizeAreaInput(env.lengthMeters);
      const W = E.normalizeAreaInput(env.widthMeters);
      out.textContent = (L > 0 && W > 0)
        ? 'Área aquecida calculada: ' + nf(Math.round(L * W * 100) / 100, 2) + ' m²'
        : 'Área aquecida calculada: —';
    }

    /* ---------- cálculo ---------- */
    calculate() {
      // limpa erros anteriores
      this.listEl.querySelectorAll('.aisen-fc__err').forEach((e) => { e.hidden = true; e.textContent = ''; });
      this.listEl.querySelectorAll('[data-length],[data-width]').forEach((e) => e.removeAttribute('aria-invalid'));

      const project = E.calculateFloorProject(this.environments, { config: this.cfg, rolls: this.rolls });
      this.project = project;

      // erro por campo, sem bloquear as demais zonas
      project.zones.forEach((z, i) => {
        if (z.status !== STATUS.INVALID_INPUT) return;
        const card = this.listEl.children[i];
        if (!card) return;
        const field = (z.error && z.error.field) || 'length';
        const input = card.querySelector(field === 'width' ? '[data-width]' : '[data-length]');
        const errEl = card.querySelector('.aisen-fc__err');
        if (input) input.setAttribute('aria-invalid', 'true');
        if (errEl) { errEl.textContent = (z.error && z.error.message) || 'Valor inválido.'; errEl.hidden = false; }
      });

      this.renderResults(project);
      this.renderSummary(project);
      this.save();
    }

    zoneMessage(z) {
      if (z.status === STATUS.VALID && z.controlType === CONTROL.CONTACTOR) return 'Devido à corrente total da zona, o termostato acionará os cabos através de uma contatora instalada no quadro elétrico.';
      if (z.status === STATUS.VALID) return 'Esta zona pode ser acionada diretamente pelo termostato.';
      if (z.status === STATUS.TECHNICAL_REVIEW) return 'A carga deste ambiente ultrapassa o limite operacional do conjunto padrão AISEN FLOOR. Solicite uma análise técnica.';
      if (z.status === STATUS.NO_COMBINATION) return 'Não encontramos uma combinação padrão dentro da faixa de dimensionamento AISEN FLOOR para esta área.';
      return '';
    }

    renderResults(project) {
      this.resultsEl.innerHTML = '';
      project.zones.forEach((z) => {
        if (z.status === STATUS.INVALID_INPUT) return;
        const card = el('article', 'aisen-fc__zone aisen-fc__zone--' + z.status);

        const head = el('div', 'aisen-fc__zonehead');
        head.appendChild(el('h4', 'aisen-fc__zoneh', 'Zona ' + z.zoneNumber + ' — ' + z.environmentName));
        const tagCls = z.status === STATUS.VALID
          ? (z.controlType === CONTROL.CONTACTOR ? 'aisen-fc__tag aisen-fc__tag--warn' : 'aisen-fc__tag aisen-fc__tag--ok')
          : 'aisen-fc__tag aisen-fc__tag--review';
        const tagTxt = z.status === STATUS.VALID
          ? (z.controlType === CONTROL.CONTACTOR ? 'Termostato + contatora' : 'Acionamento direto')
          : STATUS_LABEL[z.status];
        head.appendChild(el('span', tagCls, tagTxt));
        card.appendChild(head);

        if (z.status === STATUS.VALID || z.status === STATUS.TECHNICAL_REVIEW) {
          const dl = el('dl', 'aisen-fc__specs');
          const add = (k, v) => { const d = el('div'); d.append(el('dt', null, k), el('dd', null, v)); dl.appendChild(d); };
          add('Área aquecida', area(z.heatedArea));
          add('Potência instalada', nf(z.installedPower, 0) + ' W');
          add('Potência efetiva', nf(Math.round(z.installedWattsPerSquareMeter * 10) / 10, 1) + ' W/m²');
          add('Comprimento total', nf(z.installedLength, 0) + ' m');
          add('Corrente estimada', nf(Math.round(z.installedCurrent * 100) / 100, 2) + ' A');
          add('Tensão', this.cfg.voltage + ' V');
          card.appendChild(dl);

          const ul = el('ul', 'aisen-fc__items');
          z.selectedRolls.forEach((r) => ul.appendChild(el('li', null, r.quantity + ' × ' + r.title + ' — ' + r.lengthMeters + ' m')));
          if (z.status === STATUS.VALID) {
            const th = E.resolveThermostat(this.catalog, z.thermostatId);
            ul.appendChild(el('li', null, z.thermostatQuantity + ' × ' + ((th && th.title) || 'Termostato AISEN FLOOR')));
            ul.appendChild(el('li', null, z.europeanBoxQuantity + ' × Caixa padrão europeu 86 × 86 mm'));
            if (z.contactorQuantity) ul.appendChild(el('li', null, z.contactorQuantity + ' × Contatora WEG 25 A — bobina 220 VCA'));
          }
          const tp = z.metallicTape;
          if (z.status === STATUS.VALID && tp && tp.enabled && tp.quantity > 0) {
            ul.appendChild(el('li', null, tp.quantity + ' × Fita metálica de fixação — ' + tp.unitLengthMeters + ' m'));
          }
          card.appendChild(ul);

          if (z.status === STATUS.VALID && tp && tp.enabled && tp.quantity > 0) {
            const t = el('p', 'aisen-fc__hintline');
            t.textContent = tp.unitsPerLine === 1
              ? 'Uma unidade inteira para cada lado da instalação.'
              : 'Duas linhas paralelas de ' + nf(tp.installationLengthMeters, tp.installationLengthMeters % 1 ? 2 : 0) + ' m, uma em cada lado da instalação.';
            card.appendChild(t);
          }

          if (z.usesSmallAreaFallback) {
            const roll = z.selectedRolls[0];
            card.appendChild(el('p', 'aisen-fc__hintline',
              'Para esta área compacta, recomendamos o modelo ' + (roll ? roll.title : 'AISEN FLOOR 300 W') + '.'));
          }
        }

        const msg = this.zoneMessage(z);
        if (msg) card.appendChild(el('p', 'aisen-fc__zonemsg', msg));
        this.resultsEl.appendChild(card);
      });
    }

    renderSummary(project) {
      const t = project.totals;
      this.summaryEl.innerHTML = '';
      if (!project.zones.some((z) => z.status !== STATUS.INVALID_INPUT)) { this.summaryEl.hidden = true; return; }
      this.summaryEl.hidden = false;

      const sh = el('h3', 'aisen-fc__sh');
      if (this.icons.summary) {
        const si = el('img'); si.className = 'aisen-fc__shic'; si.src = this.icons.summary;
        si.alt = ''; si.setAttribute('aria-hidden', 'true'); si.width = 20; si.height = 20;
        sh.appendChild(si);
      }
      sh.appendChild(document.createTextNode('Resumo do projeto'));
      this.summaryEl.appendChild(sh);

      // faixa superior de totais
      const dl = el('dl', 'aisen-fc__totals');
      const add = (k, v) => { const d = el('div'); d.append(el('dt', null, k), el('dd', null, v)); dl.appendChild(d); };
      add('Área total', area(t.totalHeatedArea));
      add('Potência instalada total', nf(t.totalInstalledPower, 0) + ' W');
      add('Comprimento total de cabo', nf(t.totalInstalledLength, 0) + ' m');
      // termostatos, caixas, contatoras e fitas ficam só na tabela de materiais
      this.summaryEl.appendChild(dl);

      // mesma consolidação que alimenta o carrinho
      this.consolidated = E.buildConsolidatedProjectMaterials(project, this.catalog, { rolls: this.rolls, config: this.cfg });
      const mats = this.consolidated.materials;

      const body = el('div', 'aisen-fc__sumgrid');

      const left = el('div');
      if (mats.length) {
        left.appendChild(el('h4', 'aisen-fc__mh', 'Materiais do projeto'));
        const wrap = el('div', 'aisen-fc__tablewrap');
        const table = el('table', 'aisen-fc__table');
        const thead = el('thead');
        const trh = el('tr');
        [{ t: '', cls: 'aisen-fc__thumbcol' }, { t: 'Item' }, { t: 'Descrição' }, { t: 'Especificação' }, { t: 'Qtd.' }, { t: 'Total' }].forEach((h) => {
          const th = el('th', h.cls || null, h.t); th.scope = 'col';
          if (!h.t) th.setAttribute('aria-hidden', 'true');
          trh.appendChild(th);
        });
        thead.appendChild(trh); table.appendChild(thead);

        const tb = el('tbody');
        mats.forEach((m) => {
          const tr = el('tr');
          const c0 = el('td', 'aisen-fc__tthumb'); c0.setAttribute('data-th', '');
          const img = el('img');
          img.src = m.imageUrl || this.icons[m.type] || '';
          img.alt = '';
          img.setAttribute('aria-hidden', 'true');
          img.loading = 'lazy'; img.width = 44; img.height = 44;
          if (!m.imageUrl) img.className = 'is-icon';
          if (img.src) c0.appendChild(img);
          const c1 = el('td', 'aisen-fc__titem'); c1.setAttribute('data-th', 'Item'); c1.textContent = m.title;
          const c2 = el('td'); c2.setAttribute('data-th', 'Descrição'); c2.textContent = m.description;
          const c3 = el('td'); c3.setAttribute('data-th', 'Especificação'); c3.textContent = m.specification;
          const c4 = el('td'); c4.setAttribute('data-th', 'Qtd.'); c4.textContent = String(m.quantity);
          const c5 = el('td', 'aisen-fc__ttotal'); c5.setAttribute('data-th', 'Total'); c5.textContent = m.totalLabel;
          tr.append(c0, c1, c2, c3, c4, c5); tb.appendChild(tr);
        });
        table.appendChild(tb);
        wrap.appendChild(table);
        left.appendChild(wrap);

        const foot = el('div', 'aisen-fc__tfoot');
        foot.appendChild(el('span', null, 'Total de itens do projeto: ' + this.consolidated.totalItemUnits + ' un.'));
        foot.appendChild(el('span', null, 'Comprimento total de cabo: ' + nf(this.consolidated.totalCableLength, 0) + ' m'));
        left.appendChild(foot);
      }

      const pend = project.zones.filter((z) => z.status === STATUS.TECHNICAL_REVIEW || z.status === STATUS.NO_COMBINATION);
      if (pend.length) {
        left.appendChild(el('p', 'aisen-fc__pendbox',
          'Ambientes que exigem análise técnica e não entram no carrinho: ' + pend.map((z) => z.environmentName).join(', ') + '.'));
      }
      body.appendChild(left);

      // bloco lateral do CTA
      if (t.validEnvironmentCount > 0) {
        const side = el('aside', 'aisen-fc__side');
        side.appendChild(el('h4', 'aisen-fc__sideh', 'Pronto para avançar?'));
        side.appendChild(el('p', 'aisen-fc__sidetx', 'Adicione todo o material do projeto ao carrinho em um único clique.'));
        const btn = el('button', 'aisen-btn aisen-btn--primary aisen-fc__sidebtn');
        if (this.icons.cart) {
          const ci = el('img'); ci.className = 'aisen-fc__cartic'; ci.src = this.icons.cart;
          ci.alt = ''; ci.setAttribute('aria-hidden', 'true'); ci.width = 18; ci.height = 18;
          btn.appendChild(ci);
        }
        btn.appendChild(document.createTextNode('Adicionar projeto ao carrinho'));
        btn.type = 'button'; btn.setAttribute('data-add-cart', '');
        if (!this.consolidated.isComplete) {
          btn.disabled = true;
          btn.setAttribute('aria-describedby', 'aisen-fc-missing');
        }
        side.appendChild(btn);
        if (!this.consolidated.isComplete) {
          const p = el('p', 'aisen-fc__sidenote', 'Alguns itens do kit ainda não estão disponíveis para compra on-line: '
            + this.consolidated.missingVariants.join(', ') + '. Fale com a equipe AISEN para concluir o pedido.');
          p.id = 'aisen-fc-missing';
          side.appendChild(p);
        }
        body.appendChild(side);
      }

      this.summaryEl.appendChild(body);
    }

    announce(msg, isError) {
      this.feedbackEl.hidden = false;
      this.feedbackEl.style.color = isError ? '#DC2626' : '';
      this.feedbackEl.textContent = msg;
    }

    /* ---------- carrinho ---------- */
    addToCart(btn) {
      if (!this.project || btn.dataset.busy || btn.disabled) return;
      const { lines, missing, blocked } = E.buildFloorCartLines(this.project, this.catalog, { rolls: this.rolls, config: this.cfg });

      // composição incompleta nunca é enviada em partes
      if (blocked) {
        this.announce('Não é possível adicionar o projeto porque estes itens ainda não estão disponíveis para compra on-line: '
          + missing.join(', ') + '. Fale com a equipe AISEN para concluir o pedido.', true);
        return;
      }
      if (!lines.length) { this.announce('Nenhum item disponível para adicionar ao carrinho.', true); return; }

      btn.dataset.busy = '1'; btn.disabled = true;
      const label = btn.textContent; btn.textContent = 'Adicionando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines }),
      })
        .then((r) => { if (!r.ok) return r.json().then((d) => { throw new Error(d.description || 'Erro ao adicionar ao carrinho'); }); return r.json(); })
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && drawer.open) { try { drawer.open(); } catch (e) {} }
          const pend = this.project.totals.pendingEnvironmentCount;
          this.announce('Projeto adicionado ao carrinho ✓' + (pend ? ' ' + pend + ' ambiente(s) ficaram de fora por exigirem análise técnica.' : ''));
        })
        .catch((err) => this.announce(err.message || 'Não foi possível adicionar ao carrinho.', true))
        .finally(() => { btn.disabled = false; btn.textContent = label; delete btn.dataset.busy; });
    }
  }

  if (!customElements.get('aisen-floor-calc')) customElements.define('aisen-floor-calc', AisenFloorCalc);
})();
